import { PointerEvent, useCallback, useMemo } from 'react';
import useIsNative from './native/useIsNative';
import useNativeMessages from './native/useNativeMessages';

const useHaptics = () => {
	const isNative = useIsNative();
	const { sendNativeMessage } = useNativeMessages();

	const applyHapticImpact = useCallback(
		(impact: 'light' | 'medium' | 'heavy' | 'soft' | 'rigid') => {
			if (isNative) {
				sendNativeMessage('haptics.impact', impact);
			}
		},
		[isNative, sendNativeMessage]
	);

	const applyHapticNotification = useCallback(
		(type: 'success' | 'warning' | 'error') => {
			if (isNative) {
				sendNativeMessage('haptics.notification', type);
			}
		},
		[isNative, sendNativeMessage]
	);

	const withOnButtonPress = useMemo(
		() => ({
			onPointerUp: (
				event:
					| PointerEvent<
							| HTMLButtonElement
							| HTMLAnchorElement
							| HTMLInputElement
							| HTMLElement
							 
					  >
					| undefined
			) => {
				if (!event) return;

				// Check if the pointer location is inside the button
				const target = event.target as HTMLElement;
				const rect = target.getBoundingClientRect();
				const x = event.clientX;
				const y = event.clientY;
				if (
					x >= rect.left &&
					x <= rect.right &&
					y >= rect.top &&
					y <= rect.bottom
				) {
					applyHapticImpact('light');
				}
			},
		}),
		[applyHapticImpact]
	);

	return {
		applyHapticImpact,
		applyHapticNotification,
		withOnButtonPress,
	};
};

export default useHaptics;
